import checkinComponent from './checkin.component';
import printCheckinModule from './print';

let checkinModule = angular.module('checkin', [
  printCheckinModule
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/checkin');

  $stateProvider
    .state('checkin', {
      url: '/checkin',
      component: 'checkin',
      data: {
        requireLogin: true,
        requireACL: 'check_in.all'
      },
      parent:'app',
    });
})

.component('checkin', checkinComponent)

.name;

export default checkinModule;


// WEBPACK FOOTER //
// ./client/app/components/checkin/index.js